const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse, Offcanvas, Modal} from 'bootstrap';

require('./utilities/class_enlarge.js');
//require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_drilldown_menu.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_scrolled.js');
require('./utilities/pdw_lightbox.js');
require('./utilities/anim_init.js');
require('./utilities/pdw_woocommerce.js');
require('./utilities/ps_wishlist.js');
require('./utilities/ps_wishlist_page.js');
require('./utilities/ps_brands_directory.js');
require('./utilities/ps_price_switcher.js');
require('./utilities/ps_catalog_filters.js');
require('./utilities/ps_card_image_skeleton.js');
require('./utilities/ps_counter.js');
require('./utilities/ps_checkout_block.js');
require('./utilities/ps_checkout_pickup.js');
require('./utilities/ps_account_nav.js');
